var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiyamaLogoCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 4.41 174.13 162.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23375,0,0,1.23375,-690.9,-580.579)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.97781,0,0,1.97781,325.223,93.865)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.673775,8.25136e-17,-8.25136e-17,0.673775,51.2873,-134.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.019,568.063L180.046,568.063C161.873,567.698 147.254,552.852 147.254,534.592C147.254,528.878 148.715,523.286 151.466,518.334C148.761,513.469 144.748,509.748 139.639,507.208C133.876,515.484 131.321,524.481 131.321,534.592C131.321,561.651 153.073,583.631 180.044,583.998L180.044,584.003L205.973,584.003L205.973,485.181L190.019,485.181L190.019,568.063Z",
    style: {
      fill: "rgb(2,151,1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.673775,-8.25136e-17,8.25136e-17,-0.673775,257.485,585.765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.019,568.063L180.046,568.063C161.873,567.698 147.254,552.852 147.254,534.592C147.254,528.878 148.715,523.286 151.466,518.334C148.761,513.469 144.748,509.748 139.639,507.208C133.876,515.484 131.321,524.481 131.321,534.592C131.321,561.651 153.073,583.631 180.044,583.998L180.044,584.003L205.973,584.003L205.973,485.181L190.019,485.181L190.019,568.063Z",
    style: {
      fill: "rgb(2,151,1)",
      fillRule: "nonzero"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiyamaLogoCropped);
export default __webpack_public_path__ + "static/media/niyama_logo_cropped.e0246672.svg";
export { ForwardRef as ReactComponent };